export const world_names = new Map<number, string>([
	[8, "Oubliette transition"],
	[11, "Farm Road transition"],
	[12, "west Meridell transition"],
	[13, "Western Brightvale bridge transition"],
	[14, "Brightvale Outskirts/Crossroads transition"],
	[15, "Brightvale Coast transition"],
	[17, "Black Keep/Market Town transition"],
	[18, "Illusen's Glade/Meridell Plains transition"],
	[19, "Bogshot transition"],
	[22, "northeast drackon ridge transition"],
	[30, "werelupe woods entrance transition"],
	[31, "brightvale coast scenery"],
	[32, "Haunted Tombs transition"],
	[33, "Old Mine transition"],
	[34, "western brightvale beach scenery"],
	[200, "Bogshot Village"],
	[203, "Bogshot Sinkholes"],
	[207, "Bogshot Swamp"],
	[210, "Bogshot Apothecary"],
	[220, "Bogshot Sword Shop"],
	[225, "Bogshot Gift Shop"],
	[230, "Bogshot Fruit Shop"],
	[240, "Bogshot Repair Shop"],
	[260, "Brightvale Outskirts"],
	[261, "Rathbone Family Crypts"],
	[262, "Brightvale Village"],
	[263, "Brightvale Coast"],
	[264, "Brightvale Shield Shop"],
	[265, "Brightvale Castle"],
	[266, "Brightvale Fruit Shop"],
	[267, "Brightvale Lighthouse"],
	[268, "Brightvale Mote Shop"],
	[269, "Brightvale Treasure Map Shop"],
	[270, "Brightvale Petpet Shop"],
	[271, "Brightvale Potion Shop"],
	[274, "Dungeon Ruins"],
	[275, "Brightvale Castle transition"],
	[277, "Mountain Passage"],
	[280, "Brightvale transition"],
	[281, "Brightvale Castle transition scene"],
	[283, "Rathbone Family Crypts entrance transition"],
	[302, "Cogham Steppes (boss area)"],
	[303, "Cogham Steppes (lava cave) transition"],
	[304, "Meriload Mine"],
	[305, "Cogham Steppes"],
	[306, "Cogham Steppes / Boss Area transition"],
	[308, "Cogham Village"],
	[309, "Cogham transition"],
	[319, "Cogham Shield Shop"],
	[320, "Cogham Sword Shop"],
	[330, "Cogham Gift Shop"],
	[340, "Cogham Fruit Shop"],
	[348, "Mote Shop"],
	[355, "Abandoned Mines transition"],
	[358, "Abandoned Mines"],
	[360, "Abandoned Mines West transition"],
	[375, "Crossroads"],
	[380, "Western Brightvale"],
	[420, "Drackon Ridge"],
	[430, "Old Mine"],
	[602, "Ellis Family Farm"],
	[605, "Farm Road"],
	[608, "Root Cellar"],
	[610, "Cave under Ellis Family Farm"],
	[615, "Ellis House"],
	[625, "Small shack in Ellis Family Farm"],
	[902, "Illusen's Glade"],
	[905, "Illusen's Glade"],
	[910, "Negg Shop"],
	[912, "Gelert Assassin/Gnarfas Boss battle"],
	[1150, "Black Keep"],
	[1153, "Black Knight battle"],
	[1155, "Black Keep dungeon"],
	[1302, "Market Town"],
	[1305, "Market Town Shield Shop"],
	[1306, "Market Town Sword Shop"],
	[1307, "Market Town Gift Shop"],
	[1308, "Market Town Fruit Shop"],
	[1309, "Market Town Trader's Guild"],
	[1310, "Market Town Potion Shop"],
	[1320, "Meridell Village"],
	[1321, "Meridell Castle transition scene"],
	[1322, "Meridell Castle Courtyard"],
	[1323, "Meridell Outskirts"],
	[1324, "Haunted Tombs"],
	[1325, "Ancient Sewers"],
	[1326, "Oubliette"],
	[1327, "knight's crypts/ruined caves transition"],
	[1328, "Ruined Caves"],
	[1329, "Knight's Crypts"],
	[1334, "castle wall transition"],
	[1340, "Bandit Caves"],
	[1350, "Ancient Castle Sprites/Treasure Vault transition"],
	[1351, "Ancient Castle Spires part 1"],
	[1353, "Ancient Castle Spires part 2"],
	[1355, "Meridell Treasure Vault"],
	[1360, "Meridell Castle first/second floor"],
	[1362, "Meridell Castle transition"],
	[1364, "Meridell Castle floors 3-5"],
	[1370, "Ancient Sewers (act 3)"],
	[1380, "Meridell Shield Store"],
	[1381, "Meridell Sword Store"],
	[1382, "Meridell Gift Store"],
	[1383, "Thieves Guild's Lair"],
	[1384, "Meridell Mote Store"],
	[1385, "Meridell Potion Shop"],
	[1386, "Meridell Army Recruitment Centre"],
	[1387, "Meridell Bar"],
	[1388, "Meridell Castle Dungeon Entrance"],
	[1389, "Meridell Castle library"],
	[1390, "Meridell Castle northwest barracks"],
	[1391, "Meridell Castle west dining room"],
	[1393, "Meridell Sewers"],
	[1394, "Meridell Fruit Shop"],
	[1395, "Meridell Castle Dungeons"],
	[1396, "Meridell Castle Escape"],
	[1397, "Meridell Arena"],
	[1505, "Shadowglen Woods"],
	[1506, "Juppie Monster battle"],
	[1512, "Shadowglen Sinkholes"],
	[1515, "Shadowglen Transition"],
	[1640, "Meridell Plains"],
	[1910, "Steppe Plateau"],
	[2301, "Werelupe Burrow Upper"],
	[2302, "Werelupe Burrow Middle"],
	[2303, "Werelupe Burrow Lower"],
	[2304, "Crypt of the Fallen"],
	[2305, "Crypt of the Sentries"],
	[2306, "Crypt of the exiled"],
	[2308, "Werelupe Woods"],
	[2310, "Witch Hut"],
	[2313, "Werelupe Sinkhole"],
	[2314, "east Werelupe Woods transition"],
	[2320, "Werelupe Burrows transition"],
	[2322, "Werelupe Graveyard/Woods transition"],
	[2325, "Werelupe Graveyard"],
	[3000, "Debug area 1"],
	[3005, "Debug area 2"],
	[3550, "Endless Staircase"],
	[3610, "Fyora Palace Gardens"],
	[3613, "Unused Fyora Tower map"],
	[3615, "Fyora's Clocktower"],
	[3620, "Fyora's Library"],
	[3625, "Fyora's Palace"],
	[3628, "Fyora's Palace transition"],
	[10003, "Arena District"],
	[10004, "Bazaar District"],
	[10006, "Money District"],
	[10007, "Park District"],
	[10008, "Secret Sewers"],
	[10010, "Altador transition"],
	[10020, "Coliseum"],
	[10022, "Hero's Rest (6 puzzles)"],
	[10023, "Hero's Rest (giant elevator)"],
	[10024, "Hall of Heroes transition"],
	[10025, "Hall of Heroes transition"],
	[10026, "Sewer Shrine (beginning)"],
	[10027, "Sewer Shrine (eyeball maze)"],
	[10028, "Sewer Shrine (time challenge)"],
	[10029, "Sewer Shrine transition"],
	[10030, "Sewer Shrine transition"],
	[10031, "Treasury"],
	[10040, "Park Shrine"],
	[10041, "Bazaar District armory"],
	[10042, "Arena District sword shop"],
	[10043, "Park District food shop"],
	[10044, "Hall of Heroes"],
	[10045, "Altador Library"],
	[10046, "Altador Library"],
	[10047, "Money District potion shop"],
	[10048, "Arena District magic shop"],
	[10049, "Money District magic shop"],
	[10050, "Park District negg shop"],
	[10051, "Money District magic shop (duplicate)"],
	[11000, "Fyora Tower transition"],
	[11010, "Fyora's Tower"],
	[11020, "Vorsh's shop (duplicate)"],
	[11035, "Vorsh's shop (duplicate)"],
	[11050, "Vorsh's shop (duplicate)"],
	[11060, "Darkest Faerie battle"],
	[11070, "Vorsh's shop"],
]);
